/* eslint-disable max-classes-per-file */ // no point having separate files per error

export class InvalidExpressionError extends Error {
  translationKey = 'invalidexpression';

  constructor() {
    super('Invalid expression');
  }
}

export class DivisionByZeroError extends Error {
  translationKey = 'divisionbyzero';

  constructor() {
    super('Division by zero');
  }
}
